module.exports = __webpack_public_path__ + "img/antes_despues_308.71688cd8.png";